import { Component, computed, input } from "@angular/core";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { TranslatePipe } from "@ngx-translate/core";
import {
  Instruction,
  InstructionType,
} from "src/app/models/instruction/instruction";
import { AppState } from "src/app/ngrx/reducers";
import { InstructionSelectors } from "src/app/ngrx/selectors";

import { InstructionConfirmation } from "src/app/models/instruction/instruction-confirmation";
import { PercentPipe } from "@angular/common";
import { DashboardItemComponent } from "../../dashboard/dashboard-item/dashboard-item.component";
import { provideIcons, NgIcon } from "@ng-icons/core";
import {
  lucideBook,
  lucideCheck,
  lucideInfo,
  lucidePointer,
  lucideTrophy,
} from "@ng-icons/lucide";
import { InstructionItemComponent } from "../instruction-item/instruction-item.component";

@Component({
  selector: "app-instructions",
  templateUrl: "./instructions.component.html",
  styles: ``,
  imports: [
    TranslatePipe,
    PercentPipe,
    DashboardItemComponent,
    NgIcon,
    InstructionItemComponent,
  ],
  providers: [
    provideIcons({
      lucideBook,
      lucideCheck,
      lucidePointer,
      lucideTrophy,
      lucideInfo,
    }),
  ],
})
export class InstructionsComponent {
  instructions = this.store.selectSignal(InstructionSelectors.instructions);
  instructionType = input<InstructionType>();

  open = computed(() => {
    const instructionType = this.instructionType();
    return this.instructions().openInstructions.filter(
      (i) => i.instruction.type == instructionType,
    ).length;
  });

  confirmed = computed(() => {
    const instructionType = this.instructionType();
    return this.instructions().confirmedInstructions.filter(
      (i) => i.instruction.type == instructionType,
    ).length;
  });

  progress = computed(() => {
    const total = this.open() + this.confirmed();
    const finished = this.confirmed();

    return total > 0 ? finished / total : 0;
  });

  isLoading = computed(() => this.instructions().isLoading);

  openInstructions = computed(() => {
    const instructionType = this.instructionType();
    return this.instructions().openInstructions.filter(
      (i) => i.instruction.type == instructionType,
    );
  });

  confirmedInstructions = computed(() => {
    const instructionType = this.instructionType();
    return this.instructions().confirmedInstructions.filter(
      (i) => i.instruction.type == instructionType,
    );
  });

  constructor(
    private readonly store: Store<AppState>,
    private readonly router: Router,
  ) {}

  navigateTo(
    instruction: Instruction,
    instructionConfirmation: InstructionConfirmation,
  ) {
    let routePart = "courses";
    if (instruction.type == "Unterweisung") {
      routePart = "instructions";
    } else if (instruction.type == "Information") {
      routePart = "information";
    }

    this.router.navigate([
      routePart,
      instruction.name,
      instructionConfirmation.name,
    ]);
  }
}
